import AdminPanelIcon from '@material-design-icons/svg/filled/admin_panel_settings.svg?react';
import { Outlet, useLocation } from 'react-router';
import { DashboardHeader } from './dashboard/DashboardHeader';
import { SuperAdminNav } from './SuperAdminNav';

const SUPER_ADMIN_SECTIONS: Array<{
  match: (pathname: string) => boolean;
  title: string;
}> = [
  {
    match: (path) => path === '/super' || path === '/super/',
    title: 'Overview',
  },
  {
    match: (path) => path.startsWith('/super/users'),
    title: 'User Management',
  },
  {
    match: (path) => path.startsWith('/super/deleted-dapps'),
    title: 'Deleted Dapps',
  },
  {
    match: (path) => path.startsWith('/super/kyb'),
    title: 'KYC/KYB Management',
  },
  {
    match: (path) => path.startsWith('/super/emails'),
    title: 'Email Management',
  },
  {
    match: (path) => path.startsWith('/super/invites'),
    title: 'Invite Code Management',
  },
  { match: (path) => path.startsWith('/super/audit'), title: 'Audit History' },
  {
    match: (path) => path.startsWith('/super/metrics-ingestion'),
    title: 'Metrics Ingestion',
  },
  {
    match: (path) => path.startsWith('/super/dapp-rankings'),
    title: 'Dynamic Store Rankings',
  },
];

function getSuperAdminSectionTitle(pathname: string) {
  const normalizedPath = pathname.replace(/\/$/, '') || '/super';
  const match = SUPER_ADMIN_SECTIONS.find((section) =>
    section.match(normalizedPath),
  );
  return match?.title ?? '';
}

export function SuperAdminLayout() {
  const location = useLocation();
  const sectionTitle = getSuperAdminSectionTitle(location.pathname);
  const baseTitle = 'Super Admin Dashboard';
  const title = sectionTitle ? `${baseTitle} - ${sectionTitle}` : baseTitle;

  return (
    <div className="min-h-screen flex flex-col">
      <DashboardHeader
        icon={<AdminPanelIcon className="fill-current text-white size-6" />}
        title={title}
      />

      <SuperAdminNav />

      <Outlet />
    </div>
  );
}
